<template>
  <RouterLink
    v-if="to !== null"
    :to="to"
    :style="styles"
    :target="target"
    class="ui-link"
  >
    <UiIcon v-if="prependIcon" :icon="prependIcon" class="mb-1" />
    <slot />
  </RouterLink>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { UiIcon } from '~/ui';
import { RouterLink, type RouteLocation } from '~/infrastructure';
import { type TargetTypes } from '~/app/types.d';

export interface Props {
  to: string | RouteLocation | null;
  prependIcon?: string;
  color?: string;
  target?: TargetTypes;
}

const props = withDefaults(defineProps<Props>(), {
  to: null,
  prependIcon: undefined,
  color: 'text-link',
  target: '_blank',
});

const textColor = computed(() => {
  if (props.color === undefined || props.color === 'inherit') return 'inherit';
  if (props.color === 'currentColor') return 'currentColor';

  return `rgb(var(--v-theme-${props.color}))`;
});

const styles = computed(() => ({
  color: textColor.value,
}));
</script>

<style scoped lang="scss">
.ui-link {
  color: v-bind(textColor);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
</style>
